import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { ETNotification } from '@src/app/models/ETnotification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http:HttpClient) { }

  getNotifications(date:Date){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    // GET /notification/{personId}/date/{date}
    return this.http.get<ETNotification[]>(environment.apiUrl+'/notification/'+SessionHelper.getUserSub()+'/date/'+ date.toISOString(),httpOptions);
  }

  logout(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl+'/api/auth/logout', {}, httpOptions);
  }

  markRead(notification:ETNotification){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    notification.dateread = new Date().toISOString();
    // PUT /notification/{personId}/notification/{notificationId}
    return this.http.put<any>(environment.apiUrl+'/notification/'+SessionHelper.getUserSub()+'/date/'+notification.datecreated+'/notification/'+ notification.notificationId,JSON.stringify(notification),httpOptions);
  }
  markUnRead(notification:ETNotification){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    notification.dateread = "";
    // PUT /notification/{personId}/notification/{notificationId}
    return this.http.put<any>(environment.apiUrl+'/notification/'+SessionHelper.getUserSub()+'/date/'+notification.datecreated+'/notification/'+ notification.notificationId,JSON.stringify(notification),httpOptions);
  }

}

